const v1 = {
  fetchDiscoveryContent(queryParams) {
    return `/api/v1/discovery${queryParams}`;
  },
};

export default v1;
